// extracted by mini-css-extract-plugin
module.exports = {"pdbl-item__heading":"OrderListItem_pdbl-item__heading_3GPN0","pdbl-item__date":"OrderListItem_pdbl-item__date_16W-i"};